export default __webpack_public_path__ + "static/media/banner3.743fd62f.jpg";